import type { UserListItem } from '@/domain/users/entities/user.entity'

export type PushRecipientSortField = keyof UserListItem

export interface PushNotificationsModalState {
  showIndividualModal: boolean
  showSendToAllModal: boolean
  selectedUser: UserListItem | null
}

export const initialModalState: PushNotificationsModalState = {
  showIndividualModal: false,
  showSendToAllModal: false,
  selectedUser: null,
}
